export default "__VITE_ASSET__B8a$VrtO__"